<template>
  <div
    id="the-main-content"
    class="opc-succezz"
    :class="{
      'opc-succezz__no__promotes': !showPromotes,
      'opc-modal': $context.is.modal,
    }">
    <component :is='viewLayout'>
      <slot v-if="$slots.default" />
      <thanks v-else />
      <component :is='orderDetails' slot="details" />
      <Feedback v-if='false' slot="feedback" />
      <ZoomBasicIntroCard v-if="isZuoraOutage" slot="promotes" />
      <Promotes v-else slot="promotes" />
    </component>
  </div>
</template>

<script>
// make sure everything has a default fallback, so that it could be zero configuration
import ViewLayout from './view-layout.vue';
import Details from './details';
import DetailsMobile from './details.m.vue';
import Promotes from './promotes/promotes.vue';
import ZoomBasicIntroCard from './thanks-template/zoom-basic-intro-card.vue';
import Thanks from './thanks-template';
import Feedback from '@/views/succezz/feedback.vue';
import ViewLayoutMobile from '@/views/succezz/view-layout.m.vue';
import ViewLayoutModal from '@/views/succezz/view-layout.modal.vue';
import { mapGetters } from 'vuex';
import { BILLING_CYCLE, APM_PAYMENT_METHODS } from '@/common/constants';
export default {
  components: {
    Feedback,
    ViewLayout,
    Thanks,
    Details,
    Promotes,
    ViewLayoutMobile,
    DetailsMobile,
    ZoomBasicIntroCard,
    ViewLayoutModal
  },
  props: {
    showPromotes: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(['successConfig', 'boughtPlans', 'persistState']),
    isZuoraOutage() {
      // ALTERNATIVE CREDIT CARD FOR ZUORA OUTAGE
      return this.persistState.confirmationDetails?.isZuoraOutage && this.persistState.confirmationDetails?.apmName === APM_PAYMENT_METHODS.ALTERNATIVE_CREDIT_CARD;
    },
    viewLayout() {
      return this.$context.is.modal
        ? 'ViewLayoutModal'
        :this.$context.is.desktop
          ? 'ViewLayout'
          : 'ViewLayoutMobile';
    },
    orderDetails() {
      return this.$context.is.desktop ? 'Details' : 'DetailsMobile';
    },
    enableAddonList() {
      const hasQuarterlyPlan = this.boughtPlans.find(p => p.billing_cycle === BILLING_CYCLE.QUARTERLY);
      if (hasQuarterlyPlan) {
        return this.successConfig?.enableSMBService;
      }
      if (this.successConfig?.needBlock4currencySwitch) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang='scss'>
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/_variables.scss';
.opc-succezz__no__promotes {
  padding-bottom: 100px;
}

.opc-succezz {
  &.opc-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}

@include media(tablet) {
  .opc-succezz {
    display: flex;
    justify-content: center;

    .opc-succezz-layout {
      width: 600px;
    }
  }
}
</style>
